import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import Auth from '@/services/auth.service.js'

// Lazy-load page components
const UsersTable = () => import('../components/users/UsersTable.vue')
const CustomersTable = () => import('../components/customers/CustomersTable.vue')
const ProductsTable = () => import('../components/products/ProductsTable.vue')
const OrdersTable = () => import('../components/orders/OrdersTable.vue')
const ReportsComp = () => import('../components/reports/ReportsMenuComp.vue')
const AccountDetails = () => import('../components/account/UserAccount.vue')
const AccountEditDetails = () => import('../components/account/UserAccountEdit.vue')
const DashboardComp = () => import('../components/dashboard/DashboardComp.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/home',
    name: 'home',
    redirect: { name: 'dashboard' },  
    component: HomeView,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardComp,
        // meta: { requiredRole: 'admin' },
      },
      {
        path: 'users',
        name: 'users',
        component: UsersTable,
        meta: { requiredRole: 'admin' },
      },
      {
        path: 'customers',
        name: 'customers',
        component: CustomersTable,
      },
      {
        path: 'products',
        name: 'products',
        component: ProductsTable,
      },
      {
        path: 'orders',
        name: 'orders',
        component: OrdersTable,
      },
      {
        path: 'reports',
        name: 'reports',
        component: ReportsComp,
      },
      {
        path: 'account',
        name: 'account',
        component: AccountDetails,
      },
      {
        path: 'account/edit',
        name: 'account-edit',
        component: AccountEditDetails,
        props: true,
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Global navigation guard — auth check for all /home/* routes
router.beforeEach((to, from, next) => {
  const isHomeRoute = to.matched.some(record => record.name === 'home')
  if (!isHomeRoute) return next()

  const auth = Auth.checkAuth()
  if (!auth) return next({ name: 'login' })

  // Block non-admin users from the users page
  const role = Auth.getUserRole()
  if (to.meta.requiredRole === 'admin' && role !== 'admin') {
    return next({ name: 'customers' })
  }

  next()
})

export default router